/**
 * Aplicación web Directorio del Ayuntamiento de Zamora.
 * 
 * Desarrollo e implementación: Jaime León Pereira.
 * Ingeniero Informático de la Unidad TIC.
 */
import { useState, useEffect } from 'react';

/**
 * Hook personalizado para detectar si el dispositivo es móvil.
 * Basado en el ancho de la ventana del navegador.
 */ 
export default function useVersionMovil(breakpoint = 768) {

  // Estado inicial basado en el ancho actual de la ventana
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

  useEffect(() => {
    // Función que actualiza el estado cuando cambia el tamaño de ventana
    const handleResize = () => setIsMobile(window.innerWidth < breakpoint);

    // Escuchar eventos de cambio de tamaño
    window.addEventListener('resize', handleResize);

    // Limpiar event listener al desmontar
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]); // Se re-ejecuta si cambia el breakpoint

  return isMobile;
}
